import Vue from 'vue'
import VueRouter from 'vue-router'



const About = () =>import(/* webpackChunkName: "about_EnterpriseProfile" */ '../views/About.vue')
// import About from '../views/About.vue'
// import EnterpriseProfile from '../views/EnterpriseProfile.vue'//企业信息
const EnterpriseProfile = () =>import(/* webpackChunkName: "about_EnterpriseProfile" */ '../views/EnterpriseProfile.vue')



// import RubberMaterial from '../views/RubberMaterial.vue'  //橡胶
const RubberMaterial = () =>import(/* webpackChunkName: "Rub_Plast" */ '../views/RubberMaterial.vue')
// import RubberRight from '../views/RubberRight.vue'  //橡胶youbian
const RubberRight = () =>import(/* webpackChunkName: "Rub_Plast" */ '../views/RubberRight.vue')
const Oring = () =>import(/* webpackChunkName: "Mak_Te_su" */ '../views/Oring.vue')
const OringDeatil = () =>import(/* webpackChunkName: "Mak_Te_su" */ '../views/OringDeatil.vue')
const OringRight = () =>import(/* webpackChunkName: "Mak_Te_su" */ '../views/OringRight.vue')

const ElectronicElectrician = () =>import(/* webpackChunkName: "Mak_Te_su" */ '../views/ElectronicElectrician.vue')
const electronicsRight = () =>import(/* webpackChunkName: "Mak_Te_su" */ '../views/electronicsRight.vue')
const ElectronicsDetail = () =>import(/* webpackChunkName: "Mak_Te_su" */ '../views/ElectronicsDetail.vue')
//PlasticMaterials.vue
// import PlasticMaterials from '../views/PlasticMaterials.vue'//塑料材料
const PlasticMaterials = () =>import(/* webpackChunkName: "Rub_Plast" */ '../views/PlasticMaterials.vue')

// import MaterialsRight from '@/views/MaterialsRight.vue'//塑料右边
const MaterialsRight = () =>import(/* webpackChunkName: "Rub_Plast" */ '../views/MaterialsRight.vue')

// 硬度试验
// import HardnessTesting from '@/views/HardnessTesting.vue'//塑料右边
const HardnessTesting = () =>import(/* webpackChunkName: "Rub_Plast" */ '../views/HardnessTesting.vue')

//拉伸试验
// import TensileTest from '@/views/TensileTest.vue'
const TensileTest = () =>import(/* webpackChunkName: "Rub_Plast" */ '../views/TensileTest.vue')
// 新闻动态

// import CompanyDnamic from '@/views/CompanyDnamic.vue'
const CompanyDnamic = () =>import(/* webpackChunkName: "Com_Indu" */ '../views/CompanyDnamic.vue')
const CompanyDnamicRight = () =>import(/* webpackChunkName: "Com_Indu" */ '../views/CompanyDnamicRight.vue')
// import CompanyDnamicRight from '@/views/CompanyDnamicRight.vue'
// 行业资讯
// import IndustryInformation from '@/views/IndustryInformation.vue'
const IndustryInformation = () =>import(/* webpackChunkName: "Com_Indu" */ '../views/IndustryInformation.vue')

// 行业资讯youbian
// import InformationRight from '@/views/InformationRight.vue'
const InformationRight = () =>import(/* webpackChunkName: "Com_Indu" */ '../views/InformationRight.vue')
// 详情页面
// import Particulars from '@/views/Particulars.vue'
const Particulars = () =>import(/* webpackChunkName: "Com_Indu" */ '../views/Particulars.vue')

// 实验室中心lab_re
// import LaboratoryCenter from '@/views/LaboratoryCenter.vue'
const LaboratoryCenter = () =>import(/* webpackChunkName: "lab_re" */ '../views/LaboratoryCenter.vue')
// import LaboratoryRight from '@/views/LaboratoryRight.vue'
const LaboratoryRight = () =>import(/* webpackChunkName: "lab_re" */ '../views/LaboratoryRight.vue')
// import Recruitment from '@/views/Recruitment.vue'
const Recruitment = () =>import(/* webpackChunkName: "lab_re" */ '../views/Recruitment.vue')


// 客户服务
// import MakeAppointment from '@/views/MakeAppointment.vue'
// const MakeAppointment = () =>import(/* webpackChunkName: "Mak_Te_su" */ '../views/MakeAppointment.vue')
// 检测申请表
// import TestApplicationForm from '@/views/TestApplicationForm.vue'
const TestApplicationForm = () =>import(/* webpackChunkName: "Mak_Te_su" */ '../views/TestApplicationForm.vue')
// 报告查询

const TheReportQuery = () =>import(/* webpackChunkName: "Mak_Te_su" */ '../views/TheReportQuery.vue')
// 送检流程

const TheInspectionProcess = () =>import(/* webpackChunkName: "Mak_Te_su" */ '../views/TheInspectionProcess.vue')
// 调查和报价

const SurveyandQuotation = () =>import(/* webpackChunkName: "Mak_Te_su" */ '../views/SurveyandQuotation.vue')
// 意见或建议

const OpinionOrAdvice = () =>import(/* webpackChunkName: "Mak_Te_su" */ '../views/OpinionOrAdvice.vue')
// 检测须知

const CustomerInspection = () =>import(/* webpackChunkName: "Mak_Te_su" */ '../views/CustomerInspection.vue')

const PdfView = () =>import(/* webpackChunkName: "Mak_Te_su" */ '../components/PdfView.vue')

// https://unpkg.com/vue-router@3.0.0/dist/vue-router.js 
const routes = [
  {
    path: '/About',
    name: 'about',
    component: About,
      
  },
  {
    path: '/',
    redirect: '/About',
  },

  // o型圈检测
  {
    path: '/Oring',
    name: 'oring',
    component: Oring,
    children: [
      {
        path: '/',component: OringDeatil},
      { path: 'OringRight', component: OringRight },
    ]
  },
  // 电子电工检测
  {
    path: '/ElectronicElectrician',
    name: 'electronicElectrician',
    component: ElectronicElectrician,
    children: [
      {path: '/',component: electronicsRight},
      { path: 'ElectronicsDetail', component: ElectronicsDetail },
    ]
  },
  
// 橡胶材料

  {
    // 橡胶材料检测页面
    path: '/RubberMaterial',
    
    name: 'aubberMaterial',
    component: RubberMaterial,
    children: [
    
      {
        path: '/',
        // name: 'materialsRight',
        component: RubberRight
      },  // 硬度试验
      {path: 'HardnessTesting',component: HardnessTesting},


    ]

  },

// 企业简介
  {
    path: '/EnterpriseProfile',
    name: 'enterpriseProfile',
    component: EnterpriseProfile
  },

//塑料材料
  {
    path: '/PlasticMaterials',
    name: 'plasticMaterials',
    component: PlasticMaterials,
    children: [
    {path: '/',  component: MaterialsRight }, 


    //拉伸试验
  { path: 'TensileTest',component: TensileTest },

  ]

  },


  // 新闻
  // 公司动态
{
  path: '/CompanyDnamic',
  name: 'companyDnamic',
  component: CompanyDnamic,
  children: [
    
    {
      path: '/',

      component: CompanyDnamicRight
    }, 
    // 详情页main
    {
      path: 'Particulars',

      component: Particulars
    }, 
  ]
},
// 行业资讯
{
  path: '/IndustryInformation',
  name: 'industryInformation',
  component: IndustryInformation,
  children: [
    
    {
      path: '/',
      component: InformationRight
    }, 
    {
      path: 'Particulars',
      component: Particulars
    }, 
  ]
}, 

// 实验室中心
{
  path: '/LaboratoryCenter',
  name: 'laboratoryCenter',
  component: LaboratoryCenter,
  children: [
    
    {
      path: '/',
      // name: 'LaboratoryRight',
      component: LaboratoryRight
    }, 
   
  ]
  },
  // 人才招聘
  {
    path: '/Recruitment',
    name: 'recruitment',
    component: Recruitment,
  },
// 客户检测
// {
//   path: '/MakeAppointment',
//   name: 'makeAppointment',
//   component: MakeAppointment,
// },
// 检测申请表
{
  path: '/TestApplicationForm',
  name: 'testApplicationForm',
  component: TestApplicationForm,
},
  // 报告查询
  {
    path: '/TheReportQuery',
    name: 'theReportQuery',
    component: TheReportQuery,
  },
      // 送检流程
  { path: '/TheInspectionProcess',name: 'theInspectionProcess', component: TheInspectionProcess,},
// 调查和报价
{ path: '/SurveyandQuotation',name: 'surveyandQuotation', component: SurveyandQuotation,},
// 意见或建议
{ path: '/OpinionOrAdvice',name: 'opinionOrAdvice', component: OpinionOrAdvice,},
// 客户检测须知
{ path: '/CustomerInspection',name: 'customerInspection', component: CustomerInspection,},
{ path: '/PdfView',name: 'PdfView', component: PdfView,},
]
Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history', 
   
  routes
})


export default router
